import { makeStubAdapter } from './_stub';
export const pokiAdapter = makeStubAdapter('poki');
